import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-logo-section">
            <div className="footer-logo-container">
              <img src="/omega-logo.png" alt="Omega Ops Cybernetics Defence Corp." />
              <span className="footer-tagline"><em>Secure. Military-Grade. Resolute.</em></span>
            </div>
          </div>
          
          <div className="footer-sections">
            <div className="footer-section">
              <h3 className="footer-heading">Company</h3>
              <ul className="footer-links">
                <li><Link to="/" className="footer-link">Home</Link></li>
                <li><Link to="/#hardware" className="footer-link">Hardware</Link></li>
                <li><Link to="/#products" className="footer-link">Products</Link></li>
                <li><Link to="/#contact" className="footer-link">Contact</Link></li>
              </ul>
            </div>
            
            <div className="footer-section">
              <h3 className="footer-heading">Legal</h3>
              <ul className="footer-links">
                <li><Link to="/privacy" className="footer-link">Privacy Policy</Link></li>
                <li><Link to="/terms" className="footer-link">Terms of Use</Link></li>
              </ul>
            </div>
            
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-copyright">
        
            <p>&copy; Omega Ops Cybernetics Defence Corp. {currentYear}.</p>
            <p>All rights reserved.</p>
          </div>
          <div className="footer-tech-indicators">
            <div className="tech-indicator"></div>
            <div className="tech-indicator"></div>
            <div className="tech-indicator"></div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;